module.exports = __webpack_public_path__ + "assets/visa.eb99c97b.svg";